import { Array } from "@siteimprove/alfa-array";
/**
 * @public
 */
export var Tuple;
(function (Tuple) {
    function of(...values) {
        return values;
    }
    Tuple.of = of;
    function empty() {
        return [];
    }
    Tuple.empty = empty;
    function size(tuple) {
        return Array.size(tuple);
    }
    Tuple.size = size;
    function copy(tuple) {
        return Array.copy(tuple);
    }
    Tuple.copy = copy;
    function forEach(tuple, callback) {
        Array.forEach(tuple, callback);
    }
    Tuple.forEach = forEach;
    function map(tuple, mapper) {
        return Array.map(tuple, mapper);
    }
    Tuple.map = map;
    function reduce(tuple, reducer, accumulator) {
        return Array.reduce(tuple, reducer, accumulator);
    }
    Tuple.reduce = reduce;
    function reduceWhile(tuple, predicate, reducer, accumulator) {
        return Array.reduceWhile(tuple, predicate, reducer, accumulator);
    }
    Tuple.reduceWhile = reduceWhile;
    function reduceUntil(tuple, predicate, reducer, accumulator) {
        return Array.reduceUntil(tuple, predicate, reducer, accumulator);
    }
    Tuple.reduceUntil = reduceUntil;
    function filter(tuple, predicate) {
        return Array.filter(tuple, predicate);
    }
    Tuple.filter = filter;
    function reject(tuple, predicate) {
        return Array.filter(tuple, predicate);
    }
    Tuple.reject = reject;
    function find(tuple, predicate) {
        return Array.find(tuple, predicate);
    }
    Tuple.find = find;
    function findLast(tuple, predicate) {
        return Array.findLast(tuple, predicate);
    }
    Tuple.findLast = findLast;
    function includes(tuple, value) {
        return Array.includes(tuple, value);
    }
    Tuple.includes = includes;
    function collect(tuple, mapper) {
        return Array.collect(tuple, mapper);
    }
    Tuple.collect = collect;
    function collectFirst(tuple, mapper) {
        return Array.collectFirst(tuple, mapper);
    }
    Tuple.collectFirst = collectFirst;
    function some(tuple, predicate) {
        return Array.some(tuple, predicate);
    }
    Tuple.some = some;
    function none(tuple, predicate) {
        return Array.none(tuple, predicate);
    }
    Tuple.none = none;
    function every(tuple, predicate) {
        return Array.every(tuple, predicate);
    }
    Tuple.every = every;
    function count(tuple, predicate) {
        return Array.count(tuple, predicate);
    }
    Tuple.count = count;
    function get(tuple, index) {
        return Array.get(tuple, index);
    }
    Tuple.get = get;
    function has(tuple, index) {
        return Array.has(tuple, index);
    }
    Tuple.has = has;
    function set(tuple, index, value) {
        return Array.set(copy(tuple), index, value);
    }
    Tuple.set = set;
    function insert(tuple, index, value) {
        return Array.insert(copy(tuple), index, value);
    }
    Tuple.insert = insert;
    function append(tuple, value) {
        return Array.append(copy(tuple), value);
    }
    Tuple.append = append;
    function prepend(tuple, value) {
        return Array.prepend(copy(tuple), value);
    }
    Tuple.prepend = prepend;
    function first(tuple) {
        return Array.first(tuple);
    }
    Tuple.first = first;
    function last(tuple) {
        return Array.last(tuple);
    }
    Tuple.last = last;
    function search(tuple, value, comparer) {
        return Array.search(tuple, value, comparer);
    }
    Tuple.search = search;
    function equals(a, b) {
        return Array.equals(a, b);
    }
    Tuple.equals = equals;
    function hash(tuple, hash) {
        Array.hash(tuple, hash);
    }
    Tuple.hash = hash;
    function iterator(tuple) {
        return Array.iterator(tuple);
    }
    Tuple.iterator = iterator;
})(Tuple || (Tuple = {}));
//# sourceMappingURL=tuple.js.map